import { render } from "./AboutLRP.vue?vue&type=template&id=0592bf58&scoped=true"
import script from "./AboutLRP.vue?vue&type=script&lang=js"
export * from "./AboutLRP.vue?vue&type=script&lang=js"

import "./AboutLRP.vue?vue&type=style&index=0&id=0592bf58&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0592bf58"]])

export default __exports__